import { useCallback } from 'react';

import { ActionBar } from '@dreryk/react-components';

import { isItemEmpty } from './FormsTemplates.utils';
import { useFormsTemplatesContext } from './formsTemplatesContext';
import { formsTemplatesTranslationKeys } from './translations';

export const FormsTemplatesCancelActionBarPrimaryLink = (): JSX.Element => {
   const { activeItem, setReadOnlyItem } = useFormsTemplatesContext();

   const handleClick = useCallback(() => {
      setReadOnlyItem(isItemEmpty(activeItem) ? undefined : activeItem);
   }, [activeItem, setReadOnlyItem]);

   return (
      <ActionBar.PrimaryLink testId={'cancel'} label={formsTemplatesTranslationKeys.cancel} onClick={handleClick} />
   );
};
